const MARKER_RE = /===TASKS START===\s*\n?([\s\S]*?)\n?\s*===TASKS END===/;

export function extractMarkedBlock(raw: string): string | null {
  const match = raw.match(MARKER_RE);
  if (!match) return null;
  return match[1];
}
